import {createSelector} from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.user && state.user.list && state.user.list.isLoading),
  isLoading => isLoading
)
